import * as Sentry from "@sentry/vue";
import type { ApiException } from "./apiDashboardWrappers";
import type { ApiErrorResult } from "./apiHelpers";
import { isHeadlessBrowser } from "./commonHelpers";

export function sendSentryEvent(err: any, level?: Sentry.SeverityLevel) {
  const sentryEnabled = import.meta.env["VITE_SENTRY_ENABLED"] as boolean | undefined;
  if (!sentryEnabled || isHeadlessBrowser()) {
    return;
  }

  const apiException = err as ApiException;
  if (apiException?.status === 401)
    return;

  const errResult = err.result as ApiErrorResult;

  Sentry.captureException(err, scope => {
    if (level) {
      scope.setLevel(level);
    }
    if (errResult != null && errResult.SequenceKey != null) {
      scope.setTag("sequenceKey", errResult.SequenceKey);
    }

    return scope;
  });
}
